// Erase cookies not in the white list. Useful for getting rid of all old cookies.

clearCookiesRun.$inject = ['$window'];
export function clearCookiesRun($window) {

  let cookieWhiteList = [
    'alcmeon-auth',
    'alcmeon-last-reload-time',
    '_ga',
    '_gat',
    'rbsessionid',
    'csrftoken',
    'collapsediffs',
    'Redmine'
  ];


  //function adapted from http://stackoverflow.com/questions/595228/how-can-i-delete-all-cookies-with-javascript
  //A cookie is uniquely identified by name, domain and path.
  //The only way to delete a cookie is to make it expire so, we do that.
  function clearCookie(name, domain) {
    let dom = domain || $window.document.domain;
    let date = new Date(1).toUTCString(); // january 1, 1970
    $window.document.cookie = name + '=; expires=' + date + '; domain=' + dom + '; path=/';
  }

  let cookies = $window.document.cookie.split(';');

  for (let cookie of cookies) {
    let cookieName = cookie.split('=')[0].trim();

    if (cookieWhiteList.indexOf(cookieName) === -1) {
      clearCookie(cookieName, $window.document.domain);
    }
  }


}